import { useEffect } from "react";
import { createPortal } from "react-dom";

// Shared confirm-dialog shell.
//
// It portals to <body> on purpose: the buttons that open these dialogs sit
// inside STICKY table cells, and a sticky cell creates its own stacking
// context — a `fixed` overlay rendered inside one is trapped behind
// neighbouring cells and clipped by the scroll container, which is why the
// capacity dialog showed the grid through it with its copy cut off.
export default function Modal({ open, onClose, children, width = "max-w-xl", testid }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === "Escape") onClose?.(); };
    const prev = document.body.style.overflow;
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [open, onClose]);

  if (!open) return null;

  return createPortal(
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 p-4 animate-fade"
      onClick={onClose}
      data-testid={testid}
    >
      <div
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
        className={`${width} w-full bg-white border border-[var(--ink)] shadow-2xl p-6 max-h-[85vh] overflow-auto whitespace-normal`}
      >
        {children}
      </div>
    </div>,
    document.body
  );
}
